import React from 'react';
import { ProgressBar } from 'primereact/progressbar';

const CommonProgressBar=({dataRange,className})=>{
    return(
        <>
        <div className="progress-container">

            <ProgressBar value={dataRange}></ProgressBar>
            <div
                className="progress-value"
                style={{ left: `${dataRange}%` }}
            >
                {dataRange}%
            </div>
        </div>
        </>
    )
}
export default CommonProgressBar
